import { kDefaultTimerInterval } from "../constants";
import { handleTimer } from "../utils/handleTimer";
import { StartTime } from "../utils/StartTime";

export class QTimerMgr {
  constructor() {
    this.fWSMgr = null;
    this.fTimerTarget = null;
    this.fTimer = null;
    this.fTimers = null;
    this.fInterval = kDefaultTimerInterval;
  }

  InitTimerMgr(wsMgr) {
    this.fWSMgr = wsMgr;
    this.fTimers = [];
  }

  SetTimerInterval(interval) {
    this.fInterval = interval;
  }

  TagActiveElement(targetElement, clearTarget) {
    var elementGroup = targetElement.GetElementGroup();
    if (elementGroup != null) {
      if (clearTarget) targetElement = null;
      elementGroup["ActiveElement"] = targetElement;
    }
  }

  StartTimer(targetElement, fullRender) {
    if (this.fTimer != null) this.ClearTimer(); // This should not happen - timer should have been cleared

    this.fTimerTarget = targetElement;
    if (!fullRender) this.TagActiveElement(targetElement, false);

    this.fFullRender = fullRender;
    this.fTimer = setInterval(function () {
      handleTimer();
    }, this.fInterval); // 500
  }

  GetTimerTarget() {
    return this.fTimerTarget;
  }

  ClearTimer() {
    if (this.fTimer != null) {
      clearInterval(this.fTimer);
      this.fTimer = null;

      var theTarget = this.GetTimerTarget();
      if (theTarget != null) {
        theTarget.DoTimerFire(true);
        this.TagActiveElement(theTarget, true);
        this.fWSMgr.RenderWS();
        this.fTimerTarget = null;
      }
    }
    this.SetTimerInterval(kDefaultTimerInterval);
  }
}
